import { api } from './api';

const create = async data => {
  try {
    const result = await api.post(`/v2/funnel/csvconfig`, data);
    return result.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const update = async (id, datas) => {
  try {
    const { data } = await api.put(`/v2/funnel/csvconfig/${id}`, datas);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const get = async (funnelIds) => {
  try {
    const { data } = await api.post(`/v2/funnel/csvconfig/funnelIds`, {
      funnelIds
    });
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};
const getCsvConfigsExists = async (funnelIds) => {
  try {
    const { data } = await api.post(`/v2/funnel/csvconfig/exists`, {
      funnelIds
    });
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const deleteConfig = async id => {
  try {
    const result = await api.delete(`/v2/funnel/csvconfig/${id}`);
    return result.data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export default {
  create,
  update,
  get,
  getCsvConfigsExists,
  deleteConfig
};
